import { Components, Theme } from '@mui/material/styles';

/**
 * Publishes the accent to plain CSS.
 *
 * `styles/globals.css` styles things MUI never renders — the webkit scrollbar
 * — so it cannot reach the palette. Exposing the value as a custom property
 * keeps `palette.ts` the only place the hue is written down.
 */
export const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: (theme) => ({
    ':root': {
      '--sv-accent': theme.palette.primary.main,
      '--sv-canvas': theme.palette.background.default,
      '--sv-panel': theme.palette.background.paper,
      '--sv-scrollbar': theme.palette.studio.borders.control,
      '--sv-focus-ring': theme.palette.studio.shadows.focusRing,
    },
  }),
};
